const GLOBALS = { audioInitialized: false };
export default GLOBALS;
